import { useSelector } from 'react-redux';
import { getProductsAccess } from 'state/referenceData/referenceDataSelectors';

export function useProductsAccess() {
  return useSelector(getProductsAccess);
}
